import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/lib/auth";
import MainLayout from "@/components/MainLayout";
import HomePage from "@/pages/HomePage";
import NewsListPage from "@/pages/NewsListPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import LivesPage from "@/pages/LivesPage";
import CalendarPage from "@/pages/CalendarPage";
import AthletesPage from "@/pages/AthletesPage";
import AthleteDetailPage from "@/pages/AthleteDetailPage";
import CoachesPage from "@/pages/CoachesPage";
import CoachDetailPage from "@/pages/CoachDetailPage";
import CoachEditPage from "@/pages/CoachEditPage";
import ClubsPage from "@/pages/ClubsPage";
import ClubDetailPage from "@/pages/ClubDetailPage";
import ClubEditPage from "@/pages/ClubEditPage";
import FederationsPage from "@/pages/FederationsPage";
import FederationCockpitPage from "@/pages/FederationCockpitPage";
import FederationHubPage from "@/pages/FederationHubPage";
import FederationDetailPage from "@/pages/FederationDetailPage";
import FederationEditPage from "@/pages/FederationEditPage";
import CompetitionsPage from "@/pages/CompetitionsPage";
import CompetitionDetailPage from "@/pages/CompetitionDetailPage";
import TimelinePage from "@/pages/TimelinePage";
import SponsorsPage from "@/pages/SponsorsPage";
import ShopPage from "@/pages/ShopPage";
import MemoryPage from "@/pages/MemoryPage";
import SportMemoryPage from "@/pages/SportMemoryPage";
import SportMemoryDetailPage from "@/pages/SportMemoryDetailPage";
import EditionDetailPage from "@/pages/EditionDetailPage";
import PacificAthletesPage from "@/pages/PacificAthletesPage";
import PacificAthleteDetailPage from "@/pages/PacificAthleteDetailPage";
import AdminPacificAthletesPage from "@/pages/AdminPacificAthletesPage";
import GamesReportingPage from "@/pages/GamesReportingPage";
import AdminSportMemoryPage from "@/pages/AdminSportMemoryPage";
// V13.7 — AdminRoad2027SelectionPage supprimé (fusionné dans AdminGamesSelectionsPage).
import ContactPage from "@/pages/ContactPage";
import AidesSportifsPage from "@/pages/AidesSportifsPage";
import Road2027Page from "@/pages/Road2027Page";
import CreateProfileWizard from "@/pages/CreateProfileWizard";
import AthleteEditPage from "@/pages/AthleteEditPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import AdminSportsMonitorPage from "@/pages/AdminSportsMonitorPage";
import AdminLegacyMigrationPage from "@/pages/AdminLegacyMigrationPage";
import AdminCuratorPage from "@/pages/AdminCuratorPage";
import AdminNewsCuratorBatchPage from "@/pages/AdminNewsCuratorBatchPage";
import AdminModerationPage from "@/pages/AdminModerationPage";
import AdminCorbeillePage from "@/pages/AdminCorbeillePage";
import AdminHeroPinPage from "@/pages/AdminHeroPinPage";
import AdminFeaturedRotationPage from "@/pages/AdminFeaturedRotationPage";
import AdminContenusPage from "@/pages/AdminContenusPage";
import AdminAthletesImportsPage from "@/pages/AdminAthletesImportsPage";
import AdminGamesImportPage from "@/pages/AdminGamesImportPage";
import AdminAthletesDuplicatesPage from "@/pages/AdminAthletesDuplicatesPage";
import AdminAthleteMergePage from "@/pages/AdminAthleteMergePage";
import SoutienLandingPage from "@/pages/SoutienLandingPage";
import CampagnesListPage from "@/pages/CampagnesListPage";
import CampagneDetailPage from "@/pages/CampagneDetailPage";
import SupportCampaignDetailPage from "@/pages/SupportCampaignDetailPage";
import MesCampagnesPage from "@/pages/MesCampagnesPage";
import AdminCampaignsPage from "@/pages/AdminCampaignsPage";
import AdminSupportCampaignsPage from "@/pages/AdminSupportCampaignsPage";
import CopfDashboardPage from "@/pages/CopfDashboardPage";
import StructuresPage from "@/pages/StructuresPage";
import { Navigate } from "react-router-dom";
import AdminFundingPage from "@/pages/AdminFundingPage";
import AdminCopfRolesPage from "@/pages/AdminCopfRolesPage";
import AdminMemoryPage from "@/pages/AdminMemoryPage";
import MemoryDetailPage from "@/pages/MemoryDetailPage";
import FundingDetailPage from "@/pages/FundingDetailPage";
import RequireAuth from "@/components/RequireAuth";
import ContributeCuratorPage from "@/pages/ContributeCuratorPage";
import ContributeArticlePage from "@/pages/ContributeArticlePage";
import MineArticlesPage from "@/pages/MineArticlesPage";
import AdminContribArticlesPage from "@/pages/AdminContribArticlesPage";
import AdminEntitiesPage from "@/pages/AdminEntitiesPage";
import QuickCuratePage from "@/pages/QuickCuratePage";
import BookmarkletPage from "@/pages/BookmarkletPage";
import ValidationInboxPage from "@/pages/ValidationInboxPage";
import LegalPage from "@/pages/LegalPage";
import LegalIndexPage from "@/pages/LegalIndexPage";
import CookiesPage from "@/pages/CookiesPage";
import SearchPage from "@/pages/SearchPage";
import NotFoundPage from "@/pages/NotFoundPage";

// V9.18 — Sprint 5 : Mémoires & Livrets AITO
import MemoryBookRequestPage from "@/pages/MemoryBookRequestPage";
import MyMemoryBooksPage from "@/pages/MyMemoryBooksPage";
import AdminMemoryBooksPage from "@/pages/AdminMemoryBooksPage";
import AdminMemoryBookEditorPage from "@/pages/AdminMemoryBookEditorPage";
import AdminMemoryBookPrintPage from "@/pages/AdminMemoryBookPrintPage";
import CopfMemoryBooksPage from "@/pages/CopfMemoryBooksPage";
import CopfEntityManagerClaimsPage from "@/pages/CopfEntityManagerClaimsPage";

// V9.19 — Sprint 6 : Structures & revendications
import MyStructuresPage from "@/pages/MyStructuresPage";
import AdminEntityManagersPage from "@/pages/AdminEntityManagersPage";
import AdminUserRolesPage from "@/pages/AdminUserRolesPage";
import AdminGamesSelectionsPage from "@/pages/AdminGamesSelectionsPage";
import FederationValidationsPage from "@/pages/FederationValidationsPage";
import CopfValidationsPage from "@/pages/CopfValidationsPage";
import HelpPage from "@/pages/HelpPage";
import CopfReportingPalmaresPage from "@/pages/CopfReportingPalmaresPage";
import AdminAIAthletesPage from "@/pages/AdminAIAthletesPage";
import AdminSiteSettingsPage from "@/pages/AdminSiteSettingsPage";

// V13 — Annuaire étendu (Santé & Performance + Boutiques & Services)
import AnnuaireSantePage from "@/pages/AnnuaireSantePage";
import AnnuaireBoutiquesPage from "@/pages/AnnuaireBoutiquesPage";
import AnnuaireServicesPage from "@/pages/AnnuaireServicesPage";
import DirectorySubmitPage from "@/pages/DirectorySubmitPage";
import DirectoryEntryDetailPage from "@/pages/DirectoryEntryDetailPage";
import DirectoryEntryEditPage from "@/pages/DirectoryEntryEditPage";
import AdminDirectoryPage from "@/pages/AdminDirectoryPage";
import AdminHomeHighlightsPage from "@/pages/AdminHomeHighlightsPage";

import "@/App.css";
import { preloadAdminEmail } from "@/lib/adminContact";

export default function App() {
  useEffect(() => {
    // Définit l'URL du filigrane AITO.PF comme variable CSS globale (résolue côté navigateur)
    // Cache-bust suffixe pour forcer le rechargement après un remplacement d'asset.
    document.documentElement.style.setProperty(
      "--aito-wm-url",
      'url("/branding/aito-watermark.png?v=3")'
    );
    // V12.x — Précharge l'email admin depuis /api/site-settings (mailto centralisés).
    preloadAdminEmail();
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/actualites" element={<NewsListPage />} />
            <Route path="/actualites/:slug" element={<NewsDetailPage />} />
            <Route path="/lives" element={<LivesPage />} />
            <Route path="/calendrier" element={<CalendarPage />} />
            <Route path="/athletes" element={<AthletesPage />} />
            <Route path="/structures" element={<StructuresPage />} />
            <Route path="/athletes/:slug" element={<AthleteDetailPage />} />
            <Route path="/athletes/:id/edit" element={<AthleteEditPage />} />
            <Route path="/coachs" element={<CoachesPage />} />
            <Route path="/coachs/:slug" element={<CoachDetailPage />} />
            <Route path="/coachs/:id/edit" element={<CoachEditPage />} />
            <Route path="/clubs" element={<ClubsPage />} />
            <Route path="/clubs/:slug" element={<ClubDetailPage />} />
            <Route path="/clubs/:id/edit" element={<ClubEditPage />} />
            <Route path="/federations" element={<FederationsPage />} />
            <Route path="/federations/:slug" element={<FederationDetailPage />} />
            <Route path="/federations/:id/edit" element={<FederationEditPage />} />
            <Route path="/mes-federations" element={<RequireAuth><FederationHubPage /></RequireAuth>} />
            <Route path="/mes-federations/:slug" element={<RequireAuth><FederationCockpitPage /></RequireAuth>} />
            <Route path="/competitions" element={<CompetitionsPage />} />
            <Route path="/competitions/:slug" element={<CompetitionDetailPage />} />
            <Route path="/timeline" element={<TimelinePage />} />
            <Route path="/sponsors" element={<SponsorsPage />} />
            <Route path="/boutique" element={<ShopPage />} />
            {/* V12.x — /memoire = nouvelle page patrimoniale "Mémoire du Sport Polynésien" */}
            <Route path="/memoire" element={<SportMemoryPage />} />
            <Route path="/memoire/jeux-du-pacifique/:editionKey" element={<EditionDetailPage />} />
            <Route path="/annuaire/athletes-du-pacifique" element={<PacificAthletesPage />} />
            <Route path="/pacific-athletes/:paId" element={<PacificAthleteDetailPage />} />
            <Route path="/admin/pacific-athletes" element={<RequireAuth roles={["admin","copf"]}><AdminPacificAthletesPage /></RequireAuth>} />
            <Route path="/reporting/jeux-du-pacifique" element={<GamesReportingPage />} />
            <Route path="/patrimoine/:slug" element={<SportMemoryDetailPage />} />
            {/* Ancienne mémoire (MemoryBooks + MemoryItems) préservée */}
            <Route path="/memoire/vivante" element={<MemoryPage />} />
            <Route path="/aides-sportifs" element={<AidesSportifsPage />} />
            <Route path="/road-2027" element={<Road2027Page />} />
            <Route path="/creer-ma-fiche" element={<RequireAuth><CreateProfileWizard /></RequireAuth>} />
            <Route path="/connexion" element={<LoginPage />} />
            <Route path="/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/sports-monitor" element={<Navigate to="/admin/contenus?tab=sources" replace />} />
            <Route path="/admin/legacy-migration" element={<AdminLegacyMigrationPage />} />
            <Route path="/admin/curator" element={<Navigate to="/admin/contenus?tab=inbox" replace />} />
            <Route path="/admin/news-curator" element={<AdminNewsCuratorBatchPage />} />
            <Route path="/admin/moderation" element={<AdminModerationPage />} />
            <Route path="/admin/corbeille" element={<AdminCorbeillePage />} />
            <Route path="/admin/hero-pin" element={<AdminHeroPinPage />} />
            <Route path="/admin/featured-rotation" element={<AdminFeaturedRotationPage />} />
            {/* V9.14 — Sprint 3 : Cockpit Contenus unifié */}
            <Route path="/admin/contenus" element={<AdminContenusPage />} />
            <Route path="/admin/athletes/imports" element={<AdminAthletesImportsPage />} />
            <Route path="/admin/games-import" element={<RequireAuth allowRoles={["admin","copf"]}><AdminGamesImportPage /></RequireAuth>} />
            <Route path="/admin/athletes/duplicates" element={<AdminAthletesDuplicatesPage />} />
            <Route path="/admin/athletes/merge" element={<AdminAthleteMergePage />} />
            {/* V9.18 — Sprint 4 : Soutien aux athlètes */}
            <Route path="/soutien" element={<SoutienLandingPage />} />
            <Route path="/soutien/campagnes" element={<CampagnesListPage />} />
            <Route path="/soutien/campagnes/:slug" element={<CampagneDetailPage />} />
            <Route path="/soutien/:slug" element={<SupportCampaignDetailPage />} />
            <Route path="/mes-campagnes" element={<MesCampagnesPage />} />
            <Route path="/admin/campaigns" element={<AdminCampaignsPage />} />
            <Route path="/admin/support-campaigns" element={<AdminSupportCampaignsPage />} />
            <Route path="/admin/games-selections" element={<AdminGamesSelectionsPage />} />
            {/* V13.7 — Page dédiée fédération : ses affiliés à valider */}
            <Route path="/federation/validations" element={<RequireAuth><FederationValidationsPage /></RequireAuth>} />
            <Route path="/copf/validations" element={<RequireAuth allowRoles={["admin","copf"]}><CopfValidationsPage /></RequireAuth>} />
            <Route path="/admin/copf-validations" element={<Navigate to="/copf/validations" replace />} />
            <Route path="/copf" element={<RequireAuth allowRoles={["admin","copf"]}><CopfDashboardPage /></RequireAuth>} />
            <Route path="/copf/reporting-palmares" element={<RequireAuth allowRoles={["admin","copf"]}><CopfReportingPalmaresPage /></RequireAuth>} />
            <Route path="/admin/ai-athletes" element={<AdminAIAthletesPage />} />
            <Route path="/admin/site-settings" element={<AdminSiteSettingsPage />} />
            <Route path="/admin/funding" element={<AdminFundingPage />} />
            <Route path="/admin/aides" element={<AdminFundingPage />} />
            <Route path="/admin/copf-roles" element={<AdminCopfRolesPage />} />
            <Route path="/admin/memory" element={<AdminMemoryPage />} />
            <Route path="/admin/memoire-sport" element={<AdminSportMemoryPage />} />
            {/* V13.7 — /admin/jp2027-selection supprimé, redirection vers la queue unifiée */}
            <Route path="/admin/jp2027-selection" element={<Navigate to="/admin/games-selections" replace />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* V13 — Annuaire étendu */}
            <Route path="/annuaire/sante-performance" element={<AnnuaireSantePage />} />
            <Route path="/annuaire/boutiques-services" element={<AnnuaireBoutiquesPage />} />
            <Route path="/annuaire/services" element={<AnnuaireServicesPage />} />
            <Route path="/proposer-mon-activite" element={<DirectorySubmitPage />} />
            <Route path="/annuaire/:type/:slug" element={<DirectoryEntryDetailPage />} />
            <Route path="/annuaire/:type/:slug/edit" element={<RequireAuth><DirectoryEntryEditPage mode="edit" /></RequireAuth>} />
            <Route path="/creer-fiche-annuaire" element={<RequireAuth><DirectoryEntryEditPage mode="create" /></RequireAuth>} />
            <Route path="/admin/directory" element={<RequireAuth><AdminDirectoryPage /></RequireAuth>} />
            <Route path="/admin/home-highlights" element={<RequireAuth><AdminHomeHighlightsPage /></RequireAuth>} />
            <Route path="/memoire/:slug" element={<MemoryDetailPage />} />
            <Route path="/aides/:slug" element={<FundingDetailPage />} />
            <Route path="/funding/:slug" element={<FundingDetailPage />} />
            <Route path="/contribuer" element={<ContributeCuratorPage />} />
            <Route path="/publier-article" element={<ContributeArticlePage />} />
            <Route path="/mes-articles" element={<MineArticlesPage />} />
            <Route path="/mes-articles/:id" element={<MineArticlesPage />} />
            <Route path="/admin/articles" element={<Navigate to="/admin/contenus?tab=published" replace />} />
            <Route path="/admin/entities" element={<AdminEntitiesPage />} />
            <Route path="/quick-curate" element={<QuickCuratePage />} />
            <Route path="/bookmarklet" element={<BookmarkletPage />} />
            <Route path="/mes-validations" element={<ValidationInboxPage />} />
            {/* V9.18 — Sprint 5 : Mémoires & Livrets AITO */}
            <Route path="/memoires/nouvelle-demande" element={<RequireAuth><MemoryBookRequestPage /></RequireAuth>} />
            <Route path="/mes-memoires" element={<RequireAuth><MyMemoryBooksPage /></RequireAuth>} />
            <Route path="/admin/memoires" element={<RequireAuth><AdminMemoryBooksPage /></RequireAuth>} />
            <Route path="/admin/memoires/:id" element={<RequireAuth><AdminMemoryBookEditorPage /></RequireAuth>} />
            <Route path="/admin/memoires/:id/print" element={<RequireAuth><AdminMemoryBookPrintPage /></RequireAuth>} />
            <Route path="/copf/memoires" element={<RequireAuth><CopfMemoryBooksPage /></RequireAuth>} />
            <Route path="/copf/revendications" element={<RequireAuth><CopfEntityManagerClaimsPage /></RequireAuth>} />
            {/* V9.19 — Sprint 6 : Structures & revendications */}
            <Route path="/mes-structures" element={<RequireAuth><MyStructuresPage /></RequireAuth>} />
            <Route path="/admin/revendications" element={<RequireAuth><AdminEntityManagersPage /></RequireAuth>} />
            <Route path="/admin/personnes/:userId/roles" element={<RequireAuth><AdminUserRolesPage /></RequireAuth>} />
            <Route path="/legal" element={<LegalIndexPage />} />
            <Route path="/legal/:key" element={<LegalPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/recherche" element={<SearchPage />} />
            <Route path="/aide" element={<HelpPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
